import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'react-jss';
import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import { ComponentSettings, ThemeFluent } from '@bingads-webui-theme-2018/theme-fluent';
import { Panel } from '@bingads-webui-campaign-react/panel';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getPanelStyles } from './styles/panel-style';

export const withSidePanel = (Component) => {
  const WrappedComponent = ({
    title,
    isOpen,
    onClose,
    ...props
  }) => {
    const i18n = useContext(I18nContext);
    const classes = useDefaultStyles(getPanelStyles);
    const onCancel = useCallback(() => {
      onClose();
    }, [onClose]);

    return (
      <Panel
        isOpen={isOpen}
        onClose={onCancel}
        i18n={i18n}
        panelClassName="side-panel-dynamic-target"
        title={title}
        className={classes}
      >
        <ThemeProvider theme={{ components: ComponentSettings, core: ThemeFluent }} >
          <FluentProvider theme={webLightTheme} className={classes.flexContainer} >
            <Component {...props} onCancel={onCancel} />
          </FluentProvider>
        </ThemeProvider>
      </Panel>
    );
  };

  WrappedComponent.propTypes = {
    title: PropTypes.node.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  return WrappedComponent;
};

